/* Copyright (c) 2018 Scaper */

import * as React from "react";
import { Route, RouteComponentProps, Switch, withRouter } from "react-router";
import { Link } from "react-router-dom";
import { IApi } from "../api/api";
import {
    ADD_PAYMENT_METHOD_PATH,
    APP_PATH,
    AppPath,
    CONFIRM_PHONE_NUMBER_PATH,
    ConfirmPhoneNumberPath,
    IAppRouteParams,
    IConfirmPhoneNumberRouteParams,
    ISetPhoneNumberRouteParams,
    ISignInRouteParams,
    PAYMENT_PATH,
    PROFILE_PATH,
    SET_PHONE_NUMBER_PATH,
    SetPhoneNumberPath,
    SIGN_IN_PATH,
    SignInPath,
} from "../paths/pathIndex";
import { AppHome } from "./appHome";
import { AppNav } from "./appNav";
import { ConfirmPhoneNumber } from "./auth/confirmPhoneNumber";
import { RequireSignedInOrRedirect } from "./auth/requireSignedInOrRedirect";
import { SetPhoneNumber } from "./auth/setPhoneNumber";
import { SignInPage } from "./auth/signInPage";
import { FullScreenModal } from "./modal/fullScreenModal";
import { AddPaymentMethod } from "./payment/addPaymentMethod";
import { Payment } from "./payment/payment";
import { Profile } from "./profile/profile";

import "./app.scss";

interface IProps {
    api: IApi;
}

class AppWithoutRouter extends React.PureComponent<IProps & RouteComponentProps<any>, {}> {
    public render() {
        const { api } = this.props;
        return (
            <div className="scpr-App">
                <AppNav api={api}>
                    <Switch>
                        <Route path={APP_PATH} render={this.renderAppHome} />
                        <Route render={this.renderDefault} />
                    </Switch>

                    <FullScreenModal>
                        <Switch>
                            <Route path={CONFIRM_PHONE_NUMBER_PATH} render={this.renderConfirmPhoneNumber} />
                            <Route path={PAYMENT_PATH} render={this.renderPayment} />
                            <Route path={ADD_PAYMENT_METHOD_PATH} render={this.renderAddPaymentMethod} />
                            <Route path={PROFILE_PATH} render={this.renderProfile} />
                            <Route path={SET_PHONE_NUMBER_PATH} render={this.renderSetPhoneNumber} />
                            <Route path={SIGN_IN_PATH} render={this.renderSignIn} />
                        </Switch>
                    </FullScreenModal>
                </AppNav>
            </div>
        );
    }

    private renderAppHome = (routeProps: RouteComponentProps<IAppRouteParams>) => {
        const { api } = this.props;
        const routeParams = AppPath.parse(routeProps);
        return <AppHome api={api} routeParams={routeParams} />;
    };

    private renderConfirmPhoneNumber = (routeProps: RouteComponentProps<IConfirmPhoneNumberRouteParams>) => {
        const { api } = this.props;
        const routeParams = ConfirmPhoneNumberPath.parse(routeProps);
        return (
            <RequireSignedInOrRedirect>
                {(userInfo) => <ConfirmPhoneNumber api={api} routeParams={routeParams} userInfo={userInfo} />}
            </RequireSignedInOrRedirect>
        );
    };

    private renderAddPaymentMethod = () => {
        return (
            <RequireSignedInOrRedirect>
                {(userInfo) => <AddPaymentMethod userInfo={userInfo} />}
            </RequireSignedInOrRedirect>
        );
    };

    private renderPayment = () => {
        return (
            <RequireSignedInOrRedirect>
                {(userInfo) => <Payment userInfo={userInfo} />}
            </RequireSignedInOrRedirect>
        );
    };

    private renderProfile = () => {
        return (
            <RequireSignedInOrRedirect>
                {(userInfo) => <Profile userInfo={userInfo} />}
            </RequireSignedInOrRedirect>
        );
    };

    private renderSetPhoneNumber = (routeProps: RouteComponentProps<ISetPhoneNumberRouteParams>) => {
        const { api } = this.props;
        const routeParams = SetPhoneNumberPath.parse(routeProps);
        return (
            <RequireSignedInOrRedirect>
                {(userInfo) => <SetPhoneNumber api={api} routeParams={routeParams} userInfo={userInfo} />}
            </RequireSignedInOrRedirect>
        );
    };

    private renderSignIn = (routeProps: RouteComponentProps<ISignInRouteParams>) => {
        const { api } = this.props;
        const routeParams = SignInPath.parse(routeProps);
        return <SignInPage api={api} routeParams={routeParams} />;
    };

    private renderDefault = () => {
        return (
            <div className="section">
                <h2>Opps, something went wrong.</h2>
                <h5>Go <Link to={APP_PATH}>to the app</Link> to start over.</h5>
            </div>
        );
    };
}

export const App = withRouter(AppWithoutRouter);
